angular
    .module('vm.helpCenter')
    .controller('SearchResultsController', SearchResultsController)

function SearchResultsController($scope, $http, $filter, $timeout) {
    const vm = this;
}